import { StringObj } from '@/libs/types';
import { axios } from '@/libs/api.request';
import data from '@/locales/lang/zh-CN/data';

// 获取企业信息
export const getInfo = () => axios.request({
    url: 'sys/admin/company/get-info',
    method: 'get',
});

// 获取客户费用信息
export const getCompanyFee = () => axios.request({
    url: '/sys/admin/company/get-company-info',
    method: 'post',
    data: {
        fields: 'balance_day,balance,fee,server_fee',
    },
});

interface BuyLongData {
    month: string;
    paymentChannelName?: string;
    currencyCode?: string;
    productName?: string;
    payType?: string;
    payChannelName?: string;
    couponCode?: string;
}

// 购买长期套餐
export const buyLongTermPay = ({
    month,
    payType,
    paymentChannelName,
    currencyCode,
    productName,
    payChannelName,
    couponCode,
}: BuyLongData) => {
    const data2: any = {
        coupon_code: '',
        package_month: month,
        pay_type: payType,
        pay_channel_name: payChannelName || '',
    };
    if (paymentChannelName) {
        data2.payment_channel_name = paymentChannelName;
    }
    if (currencyCode) {
        data2.currency_code = currencyCode;
    }
    if (couponCode) {
        data2.coupon_code = couponCode;
    }
    if (productName) {
        data2.product_name = productName;
    }
    return axios.request({
        url: '/sys/admin/company/package-month',
        method: 'post',
        data: data2,
    });
};

// 更新企业信息
export const companySave = ({
    industry,
    scope,
    address,
}: StringObj) => axios.request({
    url: 'sys/admin/company/save',
    method: 'post',
    data: {
        industry_key: industry,
        scope_key: scope,
        address: address || '',
    },
});

// 获取企业抽奖信息
export const getCompanyPrize = (type?: string) => {
    const params: any = {};
    if (type) {
        params.type = type;
    }
    return axios.request({
        url: 'sys/admin/company/get-lottery-info',
        method: 'get',
        params,
    });
};

// 获取获奖奖信息
export const getPrize = () => axios.request({
    url: 'sys/admin/company/lottery',
    method: 'post',
});

// 兑奖奖奖信息
export const redeem = () => axios.request({
    url: 'sys/admin/company/redeem',
    method: 'get',
});

// 获取费用
export const getPackageInfo = (num: number, companyType: string, expireDate: number, couponCode: string) => axios.request({
    url: '/sys/company/company/get-package-info',
    method: 'post',
    data: {
        user_num: num,
        company_type: companyType,
        expire_date: expireDate,
        coupon_code: couponCode,
    },
});

// // 获取长期套餐信息
// export const getPackageMonthInfo = () => axios.request({
//     url: '/sys/company/company/get-package-month-info',
//     method: 'post'
// });

// 获取长期套餐信息
export const getPackageMonthInfo = (couponCode: string) => axios.request({
    url: '/sys/company/company/get-package-month-info',
    method: 'get',
    // data: {
    //     coupon_code: couponCode || '',
    // },
});
